/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251223
*/

'use strict';

import { getGridNavBar } from './ctssGridNavBar.js'; 
import { getPromise } from './ctssJQuery.js';
import { baseURL, getAppToken, setMenu } from './snSite.js';

const token = getAppToken();

const getMemberSermonDataAsync = async(params) => {
    const mg = token.sub;
    return await getPromise({
        url: `MemberSermons/${mg}/RptData/${mg}_sermon_${params.id}`
    });
}

const getSermonsDataAsync = async () =>
    await getPromise({ url: `MemberSermons?mg=${token.sub}` });
    
const getSermonRow = (params) => {
    return `<tr id=${params.sermon.sid}>` +
        '<td class="col-md-1">' + params.sermon.dtGiven + '</td>' +
        '<td class="col-md-4">' + params.sermon.sTitle + '</td>' +
        '<td class="col-md-3">' + params.sermon.title + '</td>' +
        '<td class="col-md-3">' + params.sermon.intro + '</td>' +
        '<td class="col-md-1 text-right">' +
        '<span class="fa fa-print mRight10"></span></td>' +
        '</tr>';
}

let pageSize = 10;
let currentIdx = 0;
let sermons = [];

const closeSermonRpt = () => {
    window.location.href = token.IsAdmin === 'True' ? '../Home/MySermons' : '../Home/MemberSermons';
}


const getSermonRows = (params) => {
    currentIdx = params.pageIdx;
    let content = '';
    const endIdx = (params.totalRows - params.pageIdx > pageSize)
        ? params.pageIdx + pageSize
        : params.pageIdx + params.totalRows - params.pageIdx;
    for (let i = params.pageIdx, l = endIdx; i < l; i++) {
        content += getSermonRow({ sermon: sermons[i] });
    }
    $('#gridSermons tbody')
        .empty()
        .append(content)
        .on('click', (e) => {
            const id = e.target.closest('tr').id;
            prepareSermonRpt({ id });
        });
;
};

const prepareSermonRpt = (params) =>
    window.location.href = `../Reports/SermonMemberNotes?id=${params.id}`;
        
const initAsync = async() => {

    setMenu();

    try {

        sermons = await getSermonsDataAsync();
        getSermonRows({ pageIdx: 0, totalRows: sermons.length });
        getGridNavBar({
            getRowFn: (params) => { return getSermonRows(params); },
            getGridStateFn: () => {
                return {
                    currentIdx: currentIdx,
                    pageSize: pageSize,
                    totalRows: sermons.length
                };
            }
        });
        $('#loader').css('display', 'none');

    } catch (error) { }
}

const showMemberSermonRptAsync = async (params) => {
    try {
        const memberSermonData = await getMemberSermonDataAsync(params);
        $("#reportViewer1")
            .telerik_ReportViewer({
                serviceUrl: `${baseURL}/api/reports`,
                templateUrl: `${baseURL}/api/ReportViewer/Template`,
                reportSource: {
                    report: 'RptSermonNotes.trdp',
                    parameters: {
                        church: memberSermonData.church,
                        groupID: memberSermonData.groupID,
                        groupImgName: memberSermonData.groupImgName,
                        groupName: memberSermonData.groupName,
                        noteObjects: JSON.stringify(memberSermonData.noteObjects),
                        subTitle: memberSermonData.subTitle,
                        title: memberSermonData.title
                    }
                },
                viewMode: telerikReportViewer.ViewModes.INTERACTIVE,
                scaleMode: telerikReportViewer.ScaleModes.SPECIFIC,
                scale: 1.0,
                enableAccessibility: false,
                sendEmail: { enabled: false }
            });
    } catch (error) { }
}

export {
    getMemberSermonDataAsync,
    getSermonsDataAsync,
    getSermonRow,
    getSermonRows,
    prepareSermonRpt
}; 

window.snMySermons = {
    closeSermonRpt,
    initAsync,
    showMemberSermonRptAsync
}